export default "__VITE_PUBLIC_ASSET__bd7d1a4c__"